/**
 * Picks v2 or v1 of the Series edit page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import SeriesAddEditPage   from './SeriesAddEditPage';
import SeriesAddEditPageV2 from './SeriesAddEditPageV2';

export default function SeriesAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? SeriesAddEditPageV2 : SeriesAddEditPage;
  return <Component {...props} />;
}
